import React from 'react';
import Home from '../../components/Home/Home';
import Canonical from '../../utils/Canonical';

const HomePage = () => {
  return (
    <>
      <Canonical path='/' title='Home' />
      <Home />
    </>
  );
};

export default HomePage;
